module.exports = __webpack_public_path__ + "31a272d75aa97b0dcb5585ff2ce638f9.ttf";